// extracted by mini-css-extract-plugin
export default {"textGray":"#606060","pointGreen":"#E9FCE9","juaFont":"'Jua', sans-serif","select":"select_box_select__iAaBy","option":"select_box_option__BFToy"};